import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// State
const state = {
  players: [
    {
      id: 0,
      color: "#DC62B7",
      name: "Farmer",
      image: "",
      selected: false,
      locations: {
        outposts: 0,
        farms: 0,
        towns: 0,
        feudums: {
          farm: 0,
          merchant: 0,
          alchemist: 0,
          knight: 0,
          noble: 0,
          monk: 0
        }
      },
      pawns: {
        farmer: 0,
        merchant: 0,
        alchemist: 0,
        knight: 0,
        noble: 0,
        monk: 0
      },
      pawnsInPlay: () => {
        return (
          this.pawns.farmer +
          this.pawns.merchant +
          this.pawns.alchemist +
          this.pawns.knight +
          this.pawns.noble +
          this.pawns.monk
        );
      },
      getStatus() {
        // FARMER STATUS
        let farmerStatus =
          this.pawns.farmer +
          this.locations.farms +
          this.locations.feudums.farm * 3;
        let hasPrimaryFarmerStatus =
          this.pawns.farmer > 0 || this.locations.feudums.farm > 0;

        // MERCHANT STATUS
        let merchantStatus =
          this.pawns.merchant +
          this.locations.towns +
          this.locations.feudums.merchant * 3;
        let hasPrimaryMerchantStatus =
          this.pawns.merchant > 0 || this.locations.feudums.merchant > 0;

        // ALCHEMIST STATUS
        let alchemistStatus =
          this.pawns.alchemist +
          this.locations.outposts +
          this.locations.feudums.alchemist * 3;
        let hasPrimaryAlchemistStatus =
          this.pawns.alchemist > 0 || this.locations.feudums.alchemist > 0;

        // KNIGHT STATUS
        let knightStatus =
          this.pawns.knight +
          this.locations.farms +
          this.locations.feudums.knight * 3;
        let hasPrimaryKnightStatus =
          this.pawns.knight > 0 || this.locations.feudums.knight > 0;

        // NOBLE STATUS
        let nobleStatus =
          this.pawns.noble +
          this.locations.towns +
          this.locations.feudums.noble * 3;
        let hasPrimaryNobleStatus =
          this.pawns.noble > 0 || this.locations.feudums.noble > 0;

        // MONK STATUS
        let monkStatus =
          this.pawns.monk +
          this.locations.outposts +
          this.locations.feudums.monk * 3;
        let hasPrimaryMonkStatus =
          this.pawns.monk > 0 || this.locations.feudums.monk > 0;

        return {
          farmerStatus,
          hasPrimaryFarmerStatus,
          merchantStatus,
          hasPrimaryMerchantStatus,
          alchemistStatus,
          hasPrimaryAlchemistStatus,
          knightStatus,
          hasPrimaryKnightStatus,
          nobleStatus,
          hasPrimaryNobleStatus,
          monkStatus,
          hasPrimaryMonkStatus
        };
      }
    },
    {
      id: 1,
      color: "#2D54BD",
      name: "Merchant",
      image: "",
      selected: false,
      locations: {
        outposts: 0,
        farms: 0,
        towns: 0,
        feudums: {
          farm: 0,
          merchant: 0,
          alchemist: 0,
          knight: 0,
          noble: 0,
          monk: 0
        }
      },
      pawns: {
        farmer: 0,
        merchant: 0,
        alchemist: 0,
        knight: 0,
        noble: 0,
        monk: 0
      },
      pawnsInPlay: () => {
        return (
          this.pawns.farmer +
          this.pawns.merchant +
          this.pawns.alchemist +
          this.pawns.knight +
          this.pawns.noble +
          this.pawns.monk
        );
      },
      getStatus() {
        // FARMER STATUS
        let farmerStatus =
          this.pawns.farmer +
          this.locations.farms +
          this.locations.feudums.farm * 3;
        let hasPrimaryFarmerStatus =
          this.pawns.farmer > 0 || this.locations.feudums.farm > 0;

        // MERCHANT STATUS
        let merchantStatus =
          this.pawns.merchant +
          this.locations.towns +
          this.locations.feudums.merchant * 3;
        let hasPrimaryMerchantStatus =
          this.pawns.merchant > 0 || this.locations.feudums.merchant > 0;

        // ALCHEMIST STATUS
        let alchemistStatus =
          this.pawns.alchemist +
          this.locations.outposts +
          this.locations.feudums.alchemist * 3;
        let hasPrimaryAlchemistStatus =
          this.pawns.alchemist > 0 || this.locations.feudums.alchemist > 0;

        // KNIGHT STATUS
        let knightStatus =
          this.pawns.knight +
          this.locations.farms +
          this.locations.feudums.knight * 3;
        let hasPrimaryKnightStatus =
          this.pawns.knight > 0 || this.locations.feudums.knight > 0;

        // NOBLE STATUS
        let nobleStatus =
          this.pawns.noble +
          this.locations.towns +
          this.locations.feudums.noble * 3;
        let hasPrimaryNobleStatus =
          this.pawns.noble > 0 || this.locations.feudums.noble > 0;

        // MONK STATUS
        let monkStatus =
          this.pawns.monk +
          this.locations.outposts +
          this.locations.feudums.monk * 3;
        let hasPrimaryMonkStatus =
          this.pawns.monk > 0 || this.locations.feudums.monk > 0;

        return {
          farmerStatus,
          hasPrimaryFarmerStatus,
          merchantStatus,
          hasPrimaryMerchantStatus,
          alchemistStatus,
          hasPrimaryAlchemistStatus,
          knightStatus,
          hasPrimaryKnightStatus,
          nobleStatus,
          hasPrimaryNobleStatus,
          monkStatus,
          hasPrimaryMonkStatus
        };
      }
    },
    {
      id: 2,
      color: "grey",
      name: "Alchemist",
      image: "",
      selected: false,
      locations: {
        outposts: 0,
        farms: 0,
        towns: 0,
        feudums: {
          farm: 0,
          merchant: 0,
          alchemist: 0,
          knight: 0,
          noble: 0,
          monk: 0
        }
      },
      pawns: {
        farmer: 0,
        merchant: 0,
        alchemist: 0,
        knight: 0,
        noble: 0,
        monk: 0
      },
      pawnsInPlay() {
        return (
          this.pawns.farmer +
          this.pawns.merchant +
          this.pawns.alchemist +
          this.pawns.knight +
          this.pawns.noble +
          this.pawns.monk
        );
      },
      getStatus() {
        // FARMER STATUS
        let farmerStatus =
          this.pawns.farmer +
          this.locations.farms +
          this.locations.feudums.farm * 3;
        let hasPrimaryFarmerStatus =
          this.pawns.farmer > 0 || this.locations.feudums.farm > 0;

        // MERCHANT STATUS
        let merchantStatus =
          this.pawns.merchant +
          this.locations.towns +
          this.locations.feudums.merchant * 3;
        let hasPrimaryMerchantStatus =
          this.pawns.merchant > 0 || this.locations.feudums.merchant > 0;

        // ALCHEMIST STATUS
        let alchemistStatus =
          this.pawns.alchemist +
          this.locations.outposts +
          this.locations.feudums.alchemist * 3;
        let hasPrimaryAlchemistStatus =
          this.pawns.alchemist > 0 || this.locations.feudums.alchemist > 0;

        // KNIGHT STATUS
        let knightStatus =
          this.pawns.knight +
          this.locations.farms +
          this.locations.feudums.knight * 3;
        let hasPrimaryKnightStatus =
          this.pawns.knight > 0 || this.locations.feudums.knight > 0;

        // NOBLE STATUS
        let nobleStatus =
          this.pawns.noble +
          this.locations.towns +
          this.locations.feudums.noble * 3;
        let hasPrimaryNobleStatus =
          this.pawns.noble > 0 || this.locations.feudums.noble > 0;

        // MONK STATUS
        let monkStatus =
          this.pawns.monk +
          this.locations.outposts +
          this.locations.feudums.monk * 3;
        let hasPrimaryMonkStatus =
          this.pawns.monk > 0 || this.locations.feudums.monk > 0;

        return {
          farmerStatus,
          hasPrimaryFarmerStatus,
          merchantStatus,
          hasPrimaryMerchantStatus,
          alchemistStatus,
          hasPrimaryAlchemistStatus,
          knightStatus,
          hasPrimaryKnightStatus,
          nobleStatus,
          hasPrimaryNobleStatus,
          monkStatus,
          hasPrimaryMonkStatus
        };
      }
    },
    {
      id: 3,
      color: "#E6CE34",
      name: "Knight",
      image: "",
      selected: false,
      locations: {
        outposts: 0,
        farms: 0,
        towns: 0,
        feudums: {
          farm: 0,
          merchant: 0,
          alchemist: 0,
          knight: 0,
          noble: 0,
          monk: 0
        }
      },
      pawns: {
        farmer: 0,
        merchant: 0,
        alchemist: 0,
        knight: 0,
        noble: 0,
        monk: 0
      },
      pawnsInPlay: () => {
        return (
          this.pawns.farmer +
          this.pawns.merchant +
          this.pawns.alchemist +
          this.pawns.knight +
          this.pawns.noble +
          this.pawns.monk
        );
      },
      getStatus() {
        // FARMER STATUS
        let farmerStatus =
          this.pawns.farmer +
          this.locations.farms +
          this.locations.feudums.farm * 3;
        let hasPrimaryFarmerStatus =
          this.pawns.farmer > 0 || this.locations.feudums.farm > 0;

        // MERCHANT STATUS
        let merchantStatus =
          this.pawns.merchant +
          this.locations.towns +
          this.locations.feudums.merchant * 3;
        let hasPrimaryMerchantStatus =
          this.pawns.merchant > 0 || this.locations.feudums.merchant > 0;

        // ALCHEMIST STATUS
        let alchemistStatus =
          this.pawns.alchemist +
          this.locations.outposts +
          this.locations.feudums.alchemist * 3;
        let hasPrimaryAlchemistStatus =
          this.pawns.alchemist > 0 || this.locations.feudums.alchemist > 0;

        // KNIGHT STATUS
        let knightStatus =
          this.pawns.knight +
          this.locations.farms +
          this.locations.feudums.knight * 3;
        let hasPrimaryKnightStatus =
          this.pawns.knight > 0 || this.locations.feudums.knight > 0;

        // NOBLE STATUS
        let nobleStatus =
          this.pawns.noble +
          this.locations.towns +
          this.locations.feudums.noble * 3;
        let hasPrimaryNobleStatus =
          this.pawns.noble > 0 || this.locations.feudums.noble > 0;

        // MONK STATUS
        let monkStatus =
          this.pawns.monk +
          this.locations.outposts +
          this.locations.feudums.monk * 3;
        let hasPrimaryMonkStatus =
          this.pawns.monk > 0 || this.locations.feudums.monk > 0;

        return {
          farmerStatus,
          hasPrimaryFarmerStatus,
          merchantStatus,
          hasPrimaryMerchantStatus,
          alchemistStatus,
          hasPrimaryAlchemistStatus,
          knightStatus,
          hasPrimaryKnightStatus,
          nobleStatus,
          hasPrimaryNobleStatus,
          monkStatus,
          hasPrimaryMonkStatus
        };
      }
    },
    {
      id: 4,
      color: "#8E952D",
      name: "Noble",
      locations: {
        outposts: 0,
        farms: 0,
        towns: 0,
        feudums: {
          farm: 0,
          merchant: 0,
          alchemist: 0,
          knight: 0,
          noble: 0,
          monk: 0
        }
      },
      pawns: {
        farmer: 0,
        merchant: 0,
        alchemist: 0,
        knight: 0,
        noble: 0,
        monk: 0
      },
      image: "",
      selected: false,
      pawnsInPlay: () => {
        return (
          this.pawns.farmer +
          this.pawns.merchant +
          this.pawns.alchemist +
          this.pawns.knight +
          this.pawns.noble +
          this.pawns.monk
        );
      },
      getStatus() {
        // FARMER STATUS
        let farmerStatus =
          this.pawns.farmer +
          this.locations.farms +
          this.locations.feudums.farm * 3;
        let hasPrimaryFarmerStatus =
          this.pawns.farmer > 0 || this.locations.feudums.farm > 0;

        // MERCHANT STATUS
        let merchantStatus =
          this.pawns.merchant +
          this.locations.towns +
          this.locations.feudums.merchant * 3;
        let hasPrimaryMerchantStatus =
          this.pawns.merchant > 0 || this.locations.feudums.merchant > 0;

        // ALCHEMIST STATUS
        let alchemistStatus =
          this.pawns.alchemist +
          this.locations.outposts +
          this.locations.feudums.alchemist * 3;
        let hasPrimaryAlchemistStatus =
          this.pawns.alchemist > 0 || this.locations.feudums.alchemist > 0;

        // KNIGHT STATUS
        let knightStatus =
          this.pawns.knight +
          this.locations.farms +
          this.locations.feudums.knight * 3;
        let hasPrimaryKnightStatus =
          this.pawns.knight > 0 || this.locations.feudums.knight > 0;

        // NOBLE STATUS
        let nobleStatus =
          this.pawns.noble +
          this.locations.towns +
          this.locations.feudums.noble * 3;
        let hasPrimaryNobleStatus =
          this.pawns.noble > 0 || this.locations.feudums.noble > 0;

        // MONK STATUS
        let monkStatus =
          this.pawns.monk +
          this.locations.outposts +
          this.locations.feudums.monk * 3;
        let hasPrimaryMonkStatus =
          this.pawns.monk > 0 || this.locations.feudums.monk > 0;

        return {
          farmerStatus,
          hasPrimaryFarmerStatus,
          merchantStatus,
          hasPrimaryMerchantStatus,
          alchemistStatus,
          hasPrimaryAlchemistStatus,
          knightStatus,
          hasPrimaryKnightStatus,
          nobleStatus,
          hasPrimaryNobleStatus,
          monkStatus,
          hasPrimaryMonkStatus
        };
      }
    },
    {
      id: 5,
      color: "#B03427",
      name: "Monk",
      locations: {
        outposts: 0,
        farms: 0,
        towns: 0,
        feudums: {
          farm: 0,
          merchant: 0,
          alchemist: 0,
          knight: 0,
          noble: 0,
          monk: 0
        }
      },
      pawns: {
        farmer: 0,
        merchant: 0,
        alchemist: 0,
        knight: 0,
        noble: 0,
        monk: 0
      },
      image: "",
      selected: false,
      pawnsInPlay: () => {
        return (
          this.pawns.farmer +
          this.pawns.merchant +
          this.pawns.alchemist +
          this.pawns.knight +
          this.pawns.noble +
          this.pawns.monk
        );
      },
      getStatus() {
        // FARMER STATUS
        let farmerStatus =
          this.pawns.farmer +
          this.locations.farms +
          this.locations.feudums.farm * 3;
        let hasPrimaryFarmerStatus =
          this.pawns.farmer > 0 || this.locations.feudums.farm > 0;

        // MERCHANT STATUS
        let merchantStatus =
          this.pawns.merchant +
          this.locations.towns +
          this.locations.feudums.merchant * 3;
        let hasPrimaryMerchantStatus =
          this.pawns.merchant > 0 || this.locations.feudums.merchant > 0;

        // ALCHEMIST STATUS
        let alchemistStatus =
          this.pawns.alchemist +
          this.locations.outposts +
          this.locations.feudums.alchemist * 3;
        let hasPrimaryAlchemistStatus =
          this.pawns.alchemist > 0 || this.locations.feudums.alchemist > 0;

        // KNIGHT STATUS
        let knightStatus =
          this.pawns.knight +
          this.locations.farms +
          this.locations.feudums.knight * 3;
        let hasPrimaryKnightStatus =
          this.pawns.knight > 0 || this.locations.feudums.knight > 0;

        // NOBLE STATUS
        let nobleStatus =
          this.pawns.noble +
          this.locations.towns +
          this.locations.feudums.noble * 3;
        let hasPrimaryNobleStatus =
          this.pawns.noble > 0 || this.locations.feudums.noble > 0;

        // MONK STATUS
        let monkStatus =
          this.pawns.monk +
          this.locations.outposts +
          this.locations.feudums.monk * 3;
        let hasPrimaryMonkStatus =
          this.pawns.monk > 0 || this.locations.feudums.monk > 0;

        return {
          farmerStatus,
          hasPrimaryFarmerStatus,
          merchantStatus,
          hasPrimaryMerchantStatus,
          alchemistStatus,
          hasPrimaryAlchemistStatus,
          knightStatus,
          hasPrimaryKnightStatus,
          nobleStatus,
          hasPrimaryNobleStatus,
          monkStatus,
          hasPrimaryMonkStatus
        };
      }
    }
  ],
  guilds: [
    {
      id: 0,
      name: 'Farmer',
      imageName: 'farmer_icon.png',
      playersWithPrimaryStatus() {
        let playersWithPrimaryStatus = state.players.filter(function(player) {
          return player.getStatus().hasPrimaryFarmerStatus;
        });

        playersWithPrimaryStatus.sort(function(a, b) {
          return a.getStatus().farmerStatus - b.getStatus().farmerStatus;
        });

        let statusInformation = [];

        playersWithPrimaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().farmerStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      },
      playersWithSecondaryStatus() {
        let playersWithSecondaryStatus = state.players.filter(function(player) {
          return (
            player.getStatus().farmerStatus > 0 &&
            !player.getStatus().hasPrimaryFarmerStatus
          );
        });

        playersWithSecondaryStatus.sort(function(a, b) {
          return a.getStatus().farmerStatus - b.getStatus().farmerStatus;
        });

        let statusInformation = [];

        playersWithSecondaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().farmerStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      }
    },
    {
      id: 1,
      name: "Merchant",
      imageName: 'merchant_icon.png',
      playersWithPrimaryStatus() {
        let playersWithPrimaryStatus = state.players.filter(function(player) {
          return player.getStatus().hasPrimaryMerchantStatus;
        });

        playersWithPrimaryStatus.sort(function(a, b) {
          return a.getStatus().merchantStatus - b.getStatus().merchantStatus;
        });

        let statusInformation = [];

        playersWithPrimaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().merchantStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      },
      playersWithSecondaryStatus() {
        let playersWithSecondaryStatus = state.players.filter(function(player) {
          return (
            player.getStatus().merchantStatus > 0 &&
            !player.getStatus().hasPrimaryMerchantStatus
          );
        });

        playersWithSecondaryStatus.sort(function(a, b) {
          return a.getStatus().merchantStatus - b.getStatus().merchantStatus;
        });

        let statusInformation = [];

        playersWithSecondaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().merchantStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      }
    },
    {
      id: 2,
      name: "Alchemist",
      imageName: 'alchemist_icon.png',
      playersWithPrimaryStatus() {
        let playersWithPrimaryStatus = state.players.filter(function(player) {
          return player.getStatus().hasPrimaryAlchemistStatus;
        });

        playersWithPrimaryStatus.sort(function(a, b) {
          return a.getStatus().alchemistStatus - b.getStatus().alchemistStatus;
        });

        let statusInformation = [];

        playersWithPrimaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().alchemistStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      },
      playersWithSecondaryStatus() {
        let playersWithSecondaryStatus = state.players.filter(function(player) {
          return (
            player.getStatus().alchemistStatus > 0 &&
            !player.getStatus().hasPrimaryAlchemistStatus
          );
        });

        playersWithSecondaryStatus.sort(function(a, b) {
          return a.getStatus().alchemistStatus - b.getStatus().alchemistStatus;
        });

        let statusInformation = [];

        playersWithSecondaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().alchemistStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      }
    },
    {
      id: 3,
      name: "Knight",
      imageName: 'knight_icon.png',
      playersWithPrimaryStatus() {
        let playersWithPrimaryStatus = state.players.filter(function(player) {
          return player.getStatus().hasPrimaryKnightStatus;
        });

        playersWithPrimaryStatus.sort(function(a, b) {
          return a.getStatus().knightStatus - b.getStatus().knightStatus;
        });

        let statusInformation = [];

        playersWithPrimaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().knightStatus
          });
        });
        
        statusInformation.sort(function(a, b) {
          return a.status - b.status;
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      },
      playersWithSecondaryStatus() {
        let playersWithSecondaryStatus = state.players.filter(function(player) {
          return (
            player.getStatus().knightStatus > 0 &&
            !player.getStatus().hasPrimaryKnightStatus
          );
        });

        playersWithSecondaryStatus.sort(function(a, b) {
          return a.getStatus().knightStatus - b.getStatus().knightStatus;
        });

        let statusInformation = [];

        playersWithSecondaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().knightStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      }
    },
    {
      id: 4,
      name: "Noble",
      imageName: 'noble_icon.png',
      playersWithPrimaryStatus() {
        let playersWithPrimaryStatus = state.players.filter(function(player) {
          return player.getStatus().hasPrimaryNobleStatus;
        });

        playersWithPrimaryStatus.sort(function(a, b) {
          return a.getStatus().nobleStatus - b.getStatus().nobleStatus;
        });

        let statusInformation = [];

        playersWithPrimaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().nobleStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      },
      playersWithSecondaryStatus() {
        let playersWithSecondaryStatus = state.players.filter(function(player) {
          return (
            player.getStatus().nobleStatus > 0 &&
            !player.getStatus().hasPrimaryNobleStatus
          );
        });

        playersWithSecondaryStatus.sort(function(a, b) {
          return a.getStatus().nobleStatus - b.getStatus().nobleStatus;
        });

        let statusInformation = [];

        playersWithSecondaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().nobleStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      }
    },
    {
      id: 5,
      name: "Monk",
      imageName: 'monk_icon.png',
      playersWithPrimaryStatus() {
        let playersWithPrimaryStatus = state.players.filter(function(player) {
          return player.getStatus().hasPrimaryMonkStatus;
        });

        playersWithPrimaryStatus.sort(function(a, b) {
          return a.getStatus().monkStatus - b.getStatus().monkStatus;
        });

        let statusInformation = [];

        playersWithPrimaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().monkStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      },
      playersWithSecondaryStatus() {
        let playersWithSecondaryStatus = state.players.filter(function(player) {
          return (
            player.getStatus().monkStatus > 0 &&
            !player.getStatus().hasPrimaryMonkStatus
          );
        });

        playersWithSecondaryStatus.sort(function(a, b) {
          return a.getStatus().monkStatus - b.getStatus().monkStatus;
        });

        let statusInformation = [];

        playersWithSecondaryStatus.forEach(function(player) {
          statusInformation.push({
            name: player.name,
            color: player.color,
            status: player.getStatus().monkStatus
          });
        });

        statusInformation.sort(compareValues('status', 'desc'));

        return statusInformation;
      }
    }
  ],
  started: false,
  anyPlayersHaveStatus() {
    return this.players.filter(function(player) {
      let status = player.getStatus();
      return (
        status.hasPrimaryFarmerStatus ||
        status.farmerStatus ||
        status.hasPrimaryMerchantStatus ||
        status.merchantStatus ||
        status.hasPrimaryAlchemistStatus ||
        status.alchemistStatus ||
        status.hasPrimaryKnightStatus ||
        status.knightStatus ||
        status.hasPrimaryNobleStatus ||
        status.nobleStatus ||
        status.hasPrimaryMonkStatus ||
        status.monkStatus
      );
    });
  }
};

// MUTATIONS
const mutations = {
  TOGGLE_STARTED(state) {
    state.started = !state.started;
  }
};

// ACTIONS
const actions = {
  toggleStarted(context) {
    context.commit("TOGGLE_STARTED");
  }
};

// GETTERS
const getters = {
  selectedPlayers: state => {
    return state.players.filter(function(player) {
      return player.selected;
    });
  }
};
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});

// HELPER FUNCTIONS
// function for dynamic sorting
function compareValues(key, order='asc') {
  return function(a, b) {
    if(!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = (typeof a[key] === 'string') ?
      a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string') ?
      b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return (
      (order == 'desc') ? (comparison * -1) : comparison
    );
  };
}